// Buttons and toggles (the tool switch, "Eigen tolerantie") keep focus after a click, so they
// must not block shortcuts; text fields and slider handles use the keys themselves.
export const ownsKeyboard = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  target.closest(
    'input:not([type="radio"]):not([type="checkbox"]), textarea, [contenteditable], [role="slider"]',
  ) != null;
